import {
  Audiotrack,
  Code,
  FolderZip,
  Image as ImageIcon,
  InsertDriveFile,
  PictureAsPdf,
  TableChart,
  TextSnippet,
  VideoFile,
  Web,
  Description,
} from "@mui/icons-material";
import type { SvgIconComponent } from "@mui/icons-material";
import { detectKind, PreviewKind } from "./previewTypes";

const KIND_TO_ICON: Record<PreviewKind, SvgIconComponent> = {
  pdf: PictureAsPdf,
  image: ImageIcon,
  video: VideoFile,
  audio: Audiotrack,
  text: TextSnippet,
  csv: TableChart,
  json: Code,
  html: Web,
  docx: Description,
  xlsx: TableChart,
  doc: Description,
  xls: TableChart,
  zip: FolderZip,
  unknown: InsertDriveFile,
};

export function getFileIconForName(name: string): SvgIconComponent {
  const kind = detectKind(name);
  return KIND_TO_ICON[kind] ?? InsertDriveFile;
}
